import _ from 'lodash'

import http from '../utils/http'
import config from '../config'
import * as constants from '@/constants'
import * as storage from '@/utils/storage'

class GameModel {
  static baseUrl = `${config.baseUrl}/game`
  static async getGameList(isinfo = true, token = '') {
    const { payload: gameList, errNo, errMsg } = await http.get(
      `${GameModel.baseUrl}/${window.location.hostname}`
    )

    const isButtonList = !!gameList.domain.data['按钮模式']
    const title = gameList.domain.data['标题'] || "JustTool 体育竞赛通"
    storage.setItem(constants.TITLE, title)
    const headlogo = !!gameList.domain.data['头部只显示LOGO']
    document.title = title
    const visible = !!gameList.domain.data['底部不显示公司名']
    const isButtonNotBg = !!gameList.domain.data['按钮图标无背景']
    let bgcolor = 'rgba(255,255,255)'
    let bannerUrl = gameList.domain.data['背景图PC'] ? {} : null
    if (bannerUrl) {
      bannerUrl.banner = gameList.domain.data['背景图PC']
      bannerUrl.bannerm = gameList.domain.data['背景图手机']

      bgcolor = gameList.domain.data['内框背景颜色'] ? gameList.domain.data['内框背景颜色'] : 'rgba(255,255,255,0.5)'

    }
    const weihu = gameList.domain.data['维护'] || ''
    const ewm = gameList.domain.data['二维码'] || ''
    const ico = gameList.domain.data['ico'] || 'http://obs3.justtool.com/images/justtool.ico'
    const language = gameList.language
    const domain = gameList.domain
    const domainName = domain.domainName
    const logoPicture = domain.logoPicture



    let obj = {}

    const IconLink = document.createElement('link');
    IconLink.setAttribute('rel', 'shortcut icon');
    IconLink.setAttribute('type', 'image/x-icon');
    IconLink.setAttribute('href', ico);
    document.head.appendChild(IconLink);
    storage.setItem(constants.ICO, ico)

    if (isinfo) {
      const newGameList = []
      for (const game of gameList.games) {
        const { payload } = await http.get(`${GameModel.baseUrl}/${game.id}/info`)
        game.descriptions = payload

        newGameList.push(_.assign({}, { enableRegister: false }, game))
      }
      obj = {
        gamelist: newGameList,
        domainName: domainName,
        logo: logoPicture
      }
    } else {
      obj = {
        gamelist: gameList.games,
        domainName: domainName,
        logo: logoPicture
      }
    }

    if (isButtonList) {
      let arr = []

      domain.data['按钮参数'].map(item => {
        if (item['生效'] != 0) {
          let aobj = null
          if (item['按钮类型'] == '赛事活动') {
            let aobjs = obj.gamelist.find(i => i.id == item['按钮参数'])
            if (aobjs) {
              aobj = _.cloneDeep(aobjs)
              aobj['图标'] = item['图标']
              aobj.label1 = item['按钮名称']
            }
          } else if (item['按钮类型'] == '链接') {
            aobj = { label: item['按钮名称'], 'URL重定向': item['按钮参数'], '图标': item['图标'] }
          } else if (item['按钮类型'] == '二维码') {
            aobj = { label: item['按钮名称'], '二维码': item['按钮参数'], '图标': item['图标'] }
          }
          if (aobj) {
            aobj['生效'] = item['生效']
            arr[parseInt(item['序号']) - 1] = aobj
          }
        }
      })
      // console.log(arr);
      let arr1 = arr.filter(item => item)
      obj.gamelist = arr1
    }
    // if (obj.gamelist.length == 0 && !token) {
    //   if (errNo == 1) {
    //     obj.noGameMsg = errMsg
    //     return obj
    //   }
    // window.location.href = 'http://www.justtool.com'
    // } else {
    obj.visible = visible
    obj.headlogo = headlogo
    obj.isButtonList = isButtonList
    obj.isButtonNotBg = isButtonNotBg
    obj.bgcolor = bgcolor
    obj.bannerUrl = bannerUrl
    obj.weihu = weihu
    obj.ewm = ewm
    obj.noGameMsg = errMsg
    obj.language = language

    if (gameList.games.length > 0 && gameList.games[0].weChat && !token) {
      // 对浏览器的UserAgent进行正则匹配，不含有微信独有标识的则为其他浏览器
      var useragent = navigator.userAgent
      if (useragent.match(/MicroMessenger/i) != 'MicroMessenger') {
        // // 这里警告框会阻塞当前页面继续加载
        // alert(
        //   '已禁止本次访问：您需使用微信扫描报名二维码或通过报名链接进入报名页面！'
        // )
        // // 以下代码是用javascript强行关闭当前页面
        // var opened = window.open('about:blank', '_self')
        // opened.opener = null
        // opened.close()
        return obj
      } else {
        const info = storage.getItem(constants.WX_INFO)
        if (!info) {
          let wxurl = gameList.domain.data.wxurl
          if (wxurl) {
            window.location.href = wxurl
          }
        } else {
          return obj
        }
      }
    } else {
      return obj
    }
    // }

  }

  static async getGameDetailByGameId(gameId) {
    const { payload: gameDetail } = await http.get(
      `${GameModel.baseUrl}/${gameId}/detail`
    )
    return gameDetail
  }

  static async getOid() {
    let { host } = window.location
    let hostarr = host.split('.')
    let hostname = hostarr[1] == 'justtool' ? hostarr[0] : host
    const { payload } = await http.get(
      `${config.baseUrl}/wechat/redirect/${hostname}/login.html`
    )
    return payload
  }

  static async getGameDetail(gameId) {
    const { payload: gameList } = await http.get(
      `${GameModel.baseUrl}/${window.location.hostname}`
    )
    const language = gameList.language
    const domain = gameList.domain
    const domainName = (language === '中文' || language === '繁体中文') ? domain.domainName : domain.domainNameE
    const logoPicture = domain.logoPicture
    storage.setItem(constants.LANGUAGE, language)
    let obj = {
      domainName: domainName,
      logo: logoPicture
    }
    const { payload: gameDetail } = await http.get(
      `${GameModel.baseUrl}/${gameId}/info2`
    )
    obj.gameDetail = gameDetail
    if (gameDetail.game.data.weChat) {
      // 对浏览器的UserAgent进行正则匹配，不含有微信独有标识的则为其他浏览器
      var useragent = navigator.userAgent
      if (useragent.match(/MicroMessenger/i) != 'MicroMessenger') {
        // 这里警告框会阻塞当前页面继续加载
        alert(
          '已禁止本次访问：您必须使用微信扫描报名二维码或通过报名链接进入报名页面！'
        )
        // 以下代码是用javascript强行关闭当前页面
        var opened = window.open('about:blank', '_self')
        opened.opener = null
        opened.close()
      }
    }

    return obj
  }
}

export default GameModel
